/**
 * Parses a JSON string or returns the original if not JSON
 */
export function fromJsonString(val, defaultValue = undefined) {
  if (!isString(val)) {
    return val || defaultValue;
  }
  try {
    return JSON.parse(val);
  } catch (error) {
    return val || defaultValue;
  }
}

/**
 * Checks if argument passed in is a string
 * @param {Any} val The argument to check
 */
export function isString(val) {
  return (
    typeof val === "string" ||
    (!!val &&
      typeof val === "object" &&
      Object.prototype.toString.call(val) === "[object String]")
  );
}
